// import React from 'react';
// import {BiArrowBack} from 'react-icons/bi';
// import {IoMdArrowForward} from 'react-icons/io';

// const Pagination = ({totalPages, currentPage, onPageChange}) => {
//   const pages = Array?.from({length: totalPages}, (_, i) => i + 1);

//   return (
//     <div className='flex flex-row items-center justify-between my-6 font-ManropeSemibold '>
//       {/* Pages */}
//       <div>{`Page ${currentPage} of ${totalPages}`}</div>
//       <div className='flex justify-center'>
//         <button
//           className='px-2 py-1 mx-2 border rounded bg-gray-200 cursor-pointer'
//           onClick={() => onPageChange(currentPage - 1)}
//           disabled={currentPage === 1}>
//           <BiArrowBack size={14} className='text-white' />
//         </button>
//         {pages?.map((page) => (
//           <button
//             key={page}
//             className={`px-3 py-1 mx-1 border rounded ${
//               page === currentPage ? 'bg-[#00296B] text-white' : ''
//             }`}
//             onClick={() => onPageChange(page)}>
//             {page}
//           </button>
//         ))}
//         <button
//           className='px-2 py-1 mx-2 border-[1px] border-primary rounded bg-gray-200 cursor-pointer'
//           onClick={() => onPageChange(currentPage + 1)}
//           disabled={currentPage === totalPages}>
//           <IoMdArrowForward size={14} className='text-secondary' />
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Pagination;

import {BiArrowBack} from 'react-icons/bi';
import {IoMdArrowForward} from 'react-icons/io';

export const PaginationSection = ({
  totalPosts,
  postsPerPage,
  currentPage,
  setCurrentPage,
}) => {
  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i++) {
    pageNumbers.push(i);
  }

  const maxPageNum = 5; // Maximum page numbers to display at once
  const pageNumLimit = Math.floor(maxPageNum / 2);

  // Calculate active page numbers to show in the middle
  const activePages = pageNumbers.slice(
    Math.max(0, currentPage - 1 - pageNumLimit),
    Math.min(currentPage - 1 + pageNumLimit + 1, pageNumbers.length)
  );

  // Function to handle moving to the next page
  const handleNextPage = () => {
    if (currentPage < pageNumbers.length) {
      setCurrentPage(currentPage + 1);
    }
  };

  // Function to handle moving to the previous page
  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Function to render page numbers with ellipsis
  const renderPages = () => {
    const renderedPages = activePages.map((page) => (
      <button
        key={page}
        onClick={() => setCurrentPage(page)}
        className={`${
          currentPage === page ? 'active-pag-btn bg-secondary text-white' : 'pag-btn'
        } px-3 py-1 mx-1 rounded`}
      >
        {page}
      </button>
    ));

    // Add ellipsis at the start if necessary
    if (activePages[0] > 1) {
      renderedPages.unshift(
        <button
          key="ellipsis-start"
          onClick={() => setCurrentPage(activePages[0] - maxPageNum)}
          className="pag-btn px-2 py-1 mx-1"
        >
          ...
        </button>
      );
    }

    // Add ellipsis at the end if necessary
    if (activePages[activePages.length - 1] < pageNumbers.length) {
      renderedPages.push(
        <button
          key="ellipsis-end"
          onClick={() => setCurrentPage(activePages[activePages.length - 1] + maxPageNum)}
          className="pag-btn px-2 py-1 mx-1"
        >
          ...
        </button>
      );
    }

    return renderedPages;
  };

  return (
    <main className="w-full justify-end font-inter pt-[10px] flex text-[14px] font-medium leading-[20px]  gap-2 items-center">
      {/* Previous Button */}
      <button
        className={`prev-next-btn flex gap-2 items-center px-3 py-1 ${
          currentPage === 1 ? 'text-gray-400 cursor-not-allowed' : ''
        }`}
        onClick={handlePrevPage}
        disabled={currentPage === 1}
      >
       <div className='px-3 py-2 bg-[#F6B40A] rounded-md'>
       <BiArrowBack className=' text-white' />
       </div>
        Prev
      </button>

      {/* Page Numbers */}
      <div className="flex items-center">{renderPages()}</div>

      {/* Next Button */}
      <button
        className={`prev-next-btn flex gap-2 items-center px-3 py-1 ${
          currentPage === pageNumbers.length ? 'text-gray-400 cursor-not-allowed' : ''
        }`}
        onClick={handleNextPage}
        disabled={currentPage === pageNumbers.length}
      >
        Next
       <div  className='px-3 py-2 bg-white border-[1px] border-primary rounded-md'>
       <IoMdArrowForward className='text-secondary' />
       </div>
      </button>
    </main>
  );
};

